export default "__VITE_ASSET__D2UGo6By__";